/* "Get this as a formal quote" for product-selector tools (batch 4, task 437).
   Same lead endpoint as the AI advisor; source "selector" makes the service title the lead
   "Quote - {Company} - {Name} (Selector)". */
(function () {
  function track(brand, name, params) {
    try {
      params = params || {}; params.brand = brand;
      if (window.gtag) { window.gtag('event', name, params); }
      else { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); }
    } catch (e) {}
  }
  function picked(root) {
    var parts = [];
    (root.dataset.summary || '').split('|').forEach(function (pair) {
      var i = pair.indexOf('='); if (i < 1) return;
      var label = pair.slice(0, i).trim(), sel = pair.slice(i + 1).trim(), node = null;
      try { node = document.querySelector(sel); } catch (e) {}
      if (!node) return;
      var v = (node.value !== undefined && node.tagName === 'INPUT') ? node.value : node.textContent;
      v = (v || '').replace(/\s+/g, ' ').trim();
      if (v) parts.push(label + ': ' + v);
    });
    return parts;
  }
  function init(root) {
    if (root.dataset.ssqReady) return; root.dataset.ssqReady = '1';
    var API = root.dataset.api, BRAND = root.dataset.brand || '', NAME = root.dataset.selector || 'Product selector';
    var form = root.querySelector('.ssq-form'), msg = form.querySelector('.saf-lead-msg'), pk = form.querySelector('.ssq-picked');
    root.querySelector('.ssq-open').addEventListener('click', function () {
      var p = picked(root);
      pk.textContent = p.length ? 'Your selection - ' + p.join('; ') : '';
      form.hidden = false; form.querySelector('input').focus();
      track(BRAND, 'selector_quote_open', { selector: NAME });
    });
    form.addEventListener('submit', function (ev) {
      ev.preventDefault(); msg.textContent = 'Sending...';
      var p = picked(root);
      fetch(API + '/api/lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        name: form.name.value, company: form.company.value, email: form.email.value, phone: form.phone.value,
        question: (NAME + (p.length ? ' - ' + p.join('; ') : '')).slice(0, 800),
        answer: '', page: location.href, boq: [], source: 'selector', selector: NAME.slice(0, 120) }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.detail ? (typeof j.detail === 'string' ? j.detail : 'Please check the phone and email fields.') : 'Request failed'); return j; }); })
        .then(function () { track(BRAND, 'generate_lead', { source: 'selector', selector: NAME }); msg.textContent = 'Received. An engineer will email your formal quote within one business day.'; form.querySelector('button[type=submit]').disabled = true; })
        .catch(function (err) { msg.textContent = err.message; });
    });
  }
  function initAll() { document.querySelectorAll('.ssq[data-api]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
